import { integer, sqliteTable, text } from 'drizzle-orm/sqlite-core';

/**
 * The local projection of `boat_models` — the models users submit themselves.
 *
 * A model built in the add-boat wizard is written here first and reaches Sanity as a draft, so the
 * boat that triggered it resolves its model locally from the moment it is saved, long before a
 * moderator publishes anything. The row is kept after publication as the offline snapshot for the
 * model, which is the one case where this is better than fetching Sanity at runtime.
 *
 * `sync_status`, `synced_at` and `published_at` are deliberately not here: they are the backend's
 * own bookkeeping about reaching Sanity, and the client's routing decision is `is_published` alone.
 *
 * Types follow the Postgres source in `boat_models.sql`: `jsonb` arrives as `text` and is parsed
 * where it is read, `bool` becomes `integer` because SQLite has no boolean, and timestamps stay
 * `text`.
 */
export const boat_models = sqliteTable('boat_models', {
  id: text('id').notNull().primaryKey(),
  laravel_id: integer('laravel_id'),

  /** The model as the Sanity `boat` document holds her, resolved rather than referenced. */
  boat_data: text('boat_data'),
  /** Off until a moderator publishes her; until then only her creator can see her. */
  is_published: integer('is_published'),

  // Denormalised off `boat_data` so a list or a picker does not parse json to name a model.
  model: text('model'),
  manufacturer_name: text('manufacturer_name'),
  year_first: integer('year_first'),

  organization_id: text('organization_id'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
});
